import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({
  children,
  adminOnly = false,
  managerOrAdmin = false,
}) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        data-testid="protected-loading"
      >
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/feed" replace />;
  }

  if (
    managerOrAdmin &&
    user.role !== "admin" &&
    !user.is_manager
  ) {
    return <Navigate to="/feed" replace />;
  }

  return children;
}
